import { all, takeLatest, put, call } from 'redux-saga/effects';
import qs from 'qs';
import {
  getPartialInitialOrganizationList,
  getPartialInitialAccountList,
  getPartialInitialContactList,
  getPartialQueryOrganizationList,
  getPartialQueryAccountList,
  getPartialQueryContactList,
} from '../../routines';
import envConfig from '../../../config';
import DROP_DOWN_LIMIT from '../../../common/constants/DropDownConstants';
import { request } from '../../../common/util/RestClient';
import { sortEntityByActivityStatus } from '../../../common/util/EntityUtils';

function* getPartialInitialOrganizationListSaga() {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/organizations/partial`;
    const params = {};

    params.limit = DROP_DOWN_LIMIT;

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialInitialOrganizationList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialInitialOrganizationList.failure({ error }));
  }
}

function* getPartialInitialAccountListSaga() {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/accounts/partial`;
    const params = {};

    params.limit = DROP_DOWN_LIMIT;

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialInitialAccountList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialInitialAccountList.failure({ error }));
  }
}

function* getPartialInitialContactListSaga() {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/contacts/partial`;
    const params = {};

    params.limit = DROP_DOWN_LIMIT;

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialInitialContactList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialInitialContactList.failure({ error }));
  }
}

function* getPartialQueryOrganizationListSaga({ payload }) {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/organizations/partial`;
    const params = { ...payload };
    params.limit = DROP_DOWN_LIMIT;

    if (params?.search) {
      params.query = payload.search.trim();
    }

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialQueryOrganizationList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialQueryOrganizationList.failure({ error }));
  }
}

function* getPartialQueryAccountListSaga({ payload }) {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/accounts/partial`;
    const params = { ...payload };
    params.limit = DROP_DOWN_LIMIT;

    if (params?.search) {
      params.query = payload.search.trim();
    }

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialQueryAccountList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialQueryAccountList.failure({ error }));
  }
}

function* getPartialQueryContactListSaga({ payload }) {
  try {
    let URL = `${envConfig.APIG_URL}entity-flat/contacts/partial`;
    const params = { ...payload };
    params.limit = DROP_DOWN_LIMIT;

    if (params?.search) {
      params.query = payload.search.trim();
    }

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialQueryContactList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialQueryContactList.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(
      getPartialInitialOrganizationList.TRIGGER,
      getPartialInitialOrganizationListSaga
    ),
    takeLatest(
      getPartialInitialAccountList.TRIGGER,
      getPartialInitialAccountListSaga
    ),
    takeLatest(
      getPartialInitialContactList.TRIGGER,
      getPartialInitialContactListSaga
    ),
    takeLatest(
      getPartialQueryOrganizationList.TRIGGER,
      getPartialQueryOrganizationListSaga
    ),
    takeLatest(
      getPartialQueryAccountList.TRIGGER,
      getPartialQueryAccountListSaga
    ),
    takeLatest(
      getPartialQueryContactList.TRIGGER,
      getPartialQueryContactListSaga
    ),
  ]);
}
